<template>
  <div class="">
    <div class="container form-signin3">
      <div class="row">
        <div
          class="col-md-12 mt-2"
          style="padding-left: 50px; padding-right: 50px">
          <h2
            class="text-start"
            style="color: rgb(29, 68, 91); font-weight: 600">
            Manage Tenants
          </h2>
        </div>
        <div class="col-md-12" style="padding-left: 50px; padding-right: 50px">
          <!-- <h2
            class="text-start"
            style="color: rgb(29, 68, 91); font-weight: 600"
          >
            Default
          </h2> -->
          <Form
            class="form-inline transparent-form p10 border-page m-t-2"
            ref="tenants"
            @submit="save()">
            <div class="col-lg-12 col-sm-12 row">
              <div class="col-lg-3 col-sm-3">
                <label
                  class="col-form-label"
                  style="display: flex; justify-content: flex-start">
                  Name
                  <span class="text-danger">*</span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  name="tenants_name"
                  placeholder="Tenants Name"
                  v-model="details.name"
                  style="width: 100% !important"
                  rules="required:tenant name"
                  :validateOnInput="true" />
                <ErrorMessage
                  name="tenants_name"
                  class="text-danger"
                  style="display: flex" />
              </div>
              <div class="col-lg-4 col-sm-4">
                <label
                  class="col-form-label"
                  style="display: flex; justify-content: flex-start">
                  Url
                  <span class="text-danger">*</span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  name="url"
                  placeholder="Url"
                  v-model="details.url"
                  style="width: 100% !important"
                  rules="required: url"
                  :validateOnInput="true" />
                <ErrorMessage
                  name="url"
                  class="text-danger"
                  style="display: flex" />
              </div>
              <div class="col-lg-2 col-sm-2 mt-4">
                <button
                  class="save-btn"
                  style="width: 85px !important; margin-top: 0 !important"
                  id="save-button">
                  ADD
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>

      <div
        class="row"
        style="padding-left: 50px; padding-right: 50px; margin-top: 5px">
        <div class="col-md-12 bg-light border-page">
          <div
            class="col-lg-2"
            style="
              font-weight: bold;
              margin-top: 10px;
              text-align: initial;
              font-size: 13px;
            ">
            Total Tenants : {{ count }}
          </div>
          <table
            id="table"
            style="margin-top: 16px"
            data-toggle="table"
            data-search="true"
            data-filter-control="true"
            data-toolbar="#toolbar"
            class="table table-sm text-center text-white table-bordered product-list table-hover">
            <thead>
              <tr>
                <th
                  class="head sorting"
                  id="id-name"
                  v-on:click="sorting('name', 'id-name')">
                  Name
                </th>
                <th class="head" v-if="role == 'SUPER_ADMIN' || role == 'ADMIN'">Action</th>
                <th class="head" v-if="role == 'SUPER_ADMIN' || role == 'ADMIN'">Go To Portal</th>
              </tr>
            </thead>
            <tbody v-show="!loader">
              <tr v-for="(data, index) in list" :key="index">
                <td class="body">
                  {{ data.name ? $helperService.getUpperCase(data.name) : "" }}
                </td>

                <td class="body" style="padding: 10px">
                  <a
                    v-on:click="showDeletePopup(data)"
                    class="fa fa-trash text-danger"
                    style="
                      cursor: pointer;
                      color: rgb(29, 68, 91);
                      font-size: 15px !important;
                    "
                    title="Delete"></a>
                </td>

                <td class="body" v-if="role == 'SUPER_ADMIN' || role == 'ADMIN'">
                  <button
                    id="btn-search"
                    type="button"
                    class="btn btn-primary mb-2"
                    style="color: azure"
                    v-on:click="goToPortal(data.url)">
                    Go To Portal
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <ErrorComponent @retry="getList(0)" ref="errorComponent" />
          <div class="row mx-0 mb-4">
            <div class="col-lg-12 mt-5 text-center">
              <div class="page-bottom-pagination text-right">
                <Pagination
                  @page-change="pageChange"
                  @items-per-page-change="itemsPerPageChange"
                  ref="listPagination" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import swal from "sweetalert2";
import moment from "moment";
// import Datepicker from "vue3-datepicker";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    ErrorComponent,
    Pagination,
  },
  name: "TransferPage",
  data() {
    return {
      loader: true,
      role: this.$store.getters.getUser?.role,
      list: [],
      details: {},
      fromDate: "",
      toDate: "",
      type: "",
      keyword: "",
      count: 0,
    };
  },
  mounted() {
    if (this.role != "SUPER_ADMIN" && this.role != "ADMIN") {
      this.$router.push("/dashboard");
      return;
    }
    this.getList(0);
  },
  methods: {
    save() {
      this.$api
        .postAPI({
          _action: "/manage-tenants",
          _body: this.details,
          _buttonId: "save-button",
        })
        .then((res) => {
          if (res) {
            this.$notify({
              title: "Success",
              type: "success",
              text: res.message,
            });
            this.$refs.tenants.resetForm();
            this.getList();
          }
        })
        .catch(() => {});
    },
    goToPortal(url) {
      if (url) {
        var link = url + "login/ADMIN";
        window.open(link);
      }
    },

    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(1, obj.order_by, obj.sort_by);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateFormLoader(true);
      this.list = [];
      var searchObj = {};

      if (this.fromDate) {
        searchObj.from_date = moment(this.fromDate).format("yyyy-MM-DD");
      }

      if (this.toDate) {
        searchObj.to_date = moment(this.toDate).format("yyyy-MM-DD");
      }
      if (orderBy) {
        searchObj.order_by = orderBy;
      }
      if (sortBy) {
        searchObj.sort_by = sortBy;
      }
      if (this.type) {
        searchObj.type = this.type;
      }
      if (this.keyword) {
        searchObj.keyword = this.keyword;
      }
      searchObj.limit = 20;
      this.$api
        .getAPI({
          _action: "/tenants-pagination-list",
          _body: searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.count = res.count;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count, 20);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Data available");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        });
    },
    reset() {
      this.fromDate = "";
      this.toDate = "";
      this.type = "";
    },
    getDate(date) {
      return date ? moment(date).format("DD/MM/YYYY hh:mm A") : "-";
    },
    getSrNo(index) {
      return this.$refs.listPagination
        ? (this.$refs.listPagination.currentPage - 1) * 10 + (index + 1)
        : index + 1;
    },
    showDeletePopup(data) {
      swal
        .fire({
          title: "Are you sure?",
          text: "Are you sure you want to delete",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          customClass: {
            confirmButton: "btn btn-blue btn-fill",
            cancelButton: "btn btn-danger btn-fill",
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.$api
              .deleteAPI({
                _action: "/delete-tenant/" + data.id,
              })
              .then((res) => {
                if (res) {
                  this.$notify({
                    title: "Success",
                    type: "success",
                    text: res.message,
                  });
                  this.getList(0);
                }
              })
              .catch(() => {});
          } else {
            this.getList(0);
          }
        });
    },
  },
};
</script>
